import { createContext, useContext, type ReactNode } from "react";
import type { AppShellMenuItem } from "./appShellMenu";

/** Bereits aufgelöster Eintrag des Produktkatalogs; kein zweiter Katalog im Shared-Kern. */
export interface PageMetadata {
  title: ReactNode;
  icon?: ReactNode;
  extra?: ReactNode;
}

export const PageMetadataContext = createContext<PageMetadata | null>(null);

export function usePageMetadata() {
  return useContext(PageMetadataContext);
}

/** Navigation und Seitenkopf lesen denselben übersetzten Menüeintrag. */
export function menuPageMetadata(items: readonly AppShellMenuItem[], key: string): PageMetadata | null {
  for (const item of items) {
    if (item.key === key && item.label) return { title: item.label };
    const child = item.children && menuPageMetadata(item.children, key);
    if (child) return child;
  }
  return null;
}
